export const trimTrailingCharacter = (char: string, data: string) =>
  data.charAt(data.length - 1) === char ? data.slice(0, -1) : data;
